import { render, staticRenderFns } from "./PaymentWidgetWithoutStore.vue?vue&type=template&id=413e40aa&"
import script from "./PaymentWidgetWithoutStore.vue?vue&type=script&lang=js&"
export * from "./PaymentWidgetWithoutStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports